<template>
  <div class="bc__ui__segment__chart">
      <div class="segments" :style="{'grid-template-columns': this.calcColumns()}">
        <span v-for="(rank, i) in this.ranks" :key="i"></span>
      </div>
  </div>
</template>

<style lang="scss" scoped >

</style>


<script>
    export default {

        props: [
            'ranks'
        ],

        components: {
            
        },

        methods: {
            calcColumns() {
                let stringCols = "";
                this.ranks.forEach((myRank)=> {
                    stringCols = stringCols + (myRank * 100) + "% ";
                })

                return stringCols
            }
        }
    }

</script>